<template>
  <div id="ExecutionFeedbackModel">
    <el-dialog v-if="dialogVisible" :close-on-click-modal="false" :destroy-on-close="true"
               :close-on-press-escape="false" :visible.sync="dialogVisible" :width="elDialogData.width"
    >
      <div slot="title" style="font-size: 16px;font-weight: bold; color:#303133">
        {{ elDialogData.title }}
      </div>
      <div v-loading="detailsStatus">
        <div v-for="(item,index) in list" :key="index">
          <el-row v-if="index <4" :gutter="16" style="padding: 12px 0">
            <el-col :lg="8" :md="8" :sm="24" :xs="24" v-for="(itemList,itemListIndex) in item" :key="itemListIndex">
              <div style="display: flex;overflow: hidden" v-if="itemList.key">
                <div style="width: 140px;display: inline-table;color: #909399">{{ itemList.title }}</div>
                <div style="flex: 1;color:#303133;overflow: hidden">
                  <div v-if="!itemList.list" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" :title="itemList.key">{{ itemList.key }}</div>
                  <div v-if="itemList.list">
                    <div style="padding:8px 0;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" v-for="(listItem,listIndex) in itemList.list" :key="listIndex">
                      {{ listItem }}
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="role === '2' && index ==4" :gutter="16" style="padding: 12px 0">
            <el-col :lg="12" :md="12" :sm="24" :xs="24" v-for="(itemList,itemListIndex) in item" :key="itemListIndex">
              <div style="display: flex;overflow: hidden">
                <div style="width: 140px;display: inline-table;color: #909399">{{ itemList.title }}</div>
                <div style="flex: 1;color:#303133;overflow: hidden">
                  <div v-if="!itemList.list" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{ itemList.key }}</div>
                  <div v-if="itemList.list">
                    <div style="padding:8px 0;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" v-for="(listItem,listIndex) in itemList.list" :key="listIndex">
                      {{ listItem }}
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="role === '2' && index ==5" :gutter="16" style="padding: 12px 0">
            <el-col :lg="24" :md="24" :sm="24" :xs="24" v-for="(itemList,itemListIndex) in item" :key="itemListIndex">
              <div style="display: flex;overflow: hidden">
                <div style="width: 140px;display: inline-table;color: #909399">{{ itemList.title }}</div>
                <div style="flex: 1;color:#303133;overflow: hidden">
                  <div v-if="!itemList.list" style="overflow: hidden;">{{ itemList.key }}</div>
                  <div v-if="itemList.list">
                    <div style="padding:8px 0;overflow: hidden;" v-for="(listItem,listIndex) in itemList.list" :key="listIndex">
                      {{ listItem }}
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="role === '2' && index >5" :gutter="16" style="padding: 12px 0">
            <el-col :lg="12" :md="12" :sm="24" :xs="24" v-for="(itemList,itemListIndex) in item" :key="itemListIndex">
              <div style="display: flex;overflow: hidden" v-if="itemList.key">
                <div style="width: 140px;display: inline-table;color: #909399">{{ itemList.title }}</div>
                <div style="flex: 1;color:#303133;overflow: hidden">
                  <div v-if="!itemList.list" style="overflow: hidden;">{{ itemList.key }} <span v-if="itemList.content" style="marginLeft:15px;"> {{ itemList.content }} </span></div>
                  <div v-if="itemList.list">
                    <div style="padding:8px 0;overflow: hidden;" v-for="(listItem,listIndex) in itemList.list" :key="listIndex">
                      {{ listItem }}
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="role === '1' && (index === list.length-1 || index === list.length-2)" :gutter="16" style="padding: 12px 0">
            <el-col :lg="12" :md="12" :sm="24" :xs="24" v-for="(itemList,itemListIndex) in item" :key="itemListIndex">
              <div style="display: flex;overflow: hidden" v-if="itemList.key">
                <div style="width: 140px;display: inline-table;color: #909399">{{ itemList.title }}</div>
                <div style="flex: 1;color:#303133;overflow: hidden">
                  <div v-if="!itemList.list" style="overflow: hidden;">{{ itemList.key }} <span v-if="itemList.content" style="marginLeft:15px;"> {{ itemList.content }} </span></div>
                  <div v-if="itemList.list">
                    <div style="padding:8px 0;overflow: hidden;" v-for="(listItem,listIndex) in itemList.list" :key="listIndex">
                      {{ listItem }}
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isNotEmpty } from '@/utils/utils';
import { ExecutionFeedbackServer } from '@/API/executionFeedback';

export default {
  name: 'ExecutionFeedbackModel',
  computed: {
    useSimplifiedForm () {
      return this.$store.state.useSimplifiedForm;
    }
  },
  data () {
    return {
      dialogVisible: false,
      detailsStatus: false,
      elDialogData: {
        title: '执行反馈',
        width: '1000px'
      },
      list: [
        [
          {
            title: '实际举办开始日期',
            key: ''
          },
          {
            title: '实际举办结束日期',
            key: ''
          }
        ],
        [
        ],
        // [
        //   {
        //     title: '活动支持情况(前期)',
        //     key: ''
        //   },
        //   {
        //     title: '活动支持情况(现场)',
        //     key: ''
        //   }
        // ],
        [
          {
            title: '客户类型',
            key: ''
          },
          {
            title: '实际参会人数',
            key: ''
          }
        ],
        [
          {
            title: '是否联合活动',
            key: ''
          },
          {
            title: '渠道签约类型',
            key: ''
          },
          {
            title: '联合的服务商/渠道',
            key: ''
          }
        ],
        [
          {
            title: '活动职责',
            key: ''
          }
        ],
        [
          {
            title: '活动板块',
            key: '华为',
            list: []
          }
        ],
        [
          {
            title: '报告内容优化',
            key: ''
          },
          {
            title: '支持人员',
            key: ''
          }
        ],
        [
          {
            title: '是否做了问卷',
            key: ''
          },
          {
            title: '未收集问卷的原因',
            key: ''
          }
        ],
        [
          {
            title: '回收问卷数',
            key: ''
          },
          {
            title: '销售线索条数',
            key: ''
          }
        ]
      ],
      role: '1'
    };
  },
  mounted () {
    // this.feedbackOneAxios('fe934c84171045a5828b2673e527a20d');
  },
  methods: {
    handleOpen (row) {
      this.role = row.userType;
      this.detailsStatus = true;
      this.dialogVisible = true;
      this.feedbackOneAxios(row.id);
    },
    async feedbackOneAxios (feedbackId) {
      try {
        const result = await ExecutionFeedbackServer.feedbackOne(feedbackId);
        if (result.status === '200') {
          const dataCopy = JSON.parse(JSON.stringify(result.data));
          this.list[0][0].key = dataCopy.mactFeedback.realStartDate.split(' ')[0];
          this.list[0][1].key = dataCopy.mactFeedback.realEndDate.split(' ')[0];
          if (isNotEmpty(dataCopy.fbEarly) || isNotEmpty(dataCopy.fbLater)) {
            const activitySupport = [
                {
                  title: '活动支持情况(前期)',
                  key: ''
                },
                {
                  title: '活动支持情况(现场)',
                  key: ''
                }
            ];
            this.$set(this.list, [1], activitySupport);
            this.list[1][0].key = '';
            dataCopy.fbEarly.forEach(item => {
              this.list[1][0].key += `${item.fieldName},`;
            });
            this.list[1][0].key = this.list[1][0].key.substring(0, this.list[1][0].key.length - 1);
            this.list[1][1].key = '';
            dataCopy.fbLater.forEach(item => {
              this.list[1][1].key += `${item.fieldName},`;
            });
            this.list[1][1].key = this.list[1][1].key.substring(0, this.list[1][1].key.length - 1);
          } else {
            const productSupport = [
              {
                title: '品推支持情况',
                key: ''
              }
            ];
            this.$set(this.list, [1], productSupport);
            this.list.push([
              {
                title: '是否重要活动',
                key: ''
              },
              {
                title: '备注',
                key: '',
                content: ''
              }
            ],
            [
              {
                title: '原始活动单号',
                key: ''
              }
            ]);
            this.list[1][0].key = dataCopy.fbSupportSituation[0].fieldValue;
            this.list[9][0].key = dataCopy.mactFeedback.isImportantActivity ? '是' : '否';
            this.list[9][1].key = '';
            this.list[9][1].content = '';
            this.list[10][0].key = '';
            if (dataCopy.fbRemarks && dataCopy.fbRemarks.length) {
              dataCopy.fbRemarks.forEach((item, i) => {
                if (i !== dataCopy.fbRemarks.length - 1) {
                  this.list[9][1].key += item.fieldValue + '、';
                } else {
                  this.list[9][1].key += item.fieldValue;
                }
              });
              if (dataCopy.fbRemarks.findIndex(item => item.fieldKey === 'REMARKS_04') !== -1) {
                this.list[9][1].content = dataCopy.mactFeedback.other;
              }
              if (dataCopy.fbRemarks.findIndex(item => item.fieldKey === 'REMARKS_01') !== -1) {
                this.list[10][0].key = dataCopy.mactFeedback.relationCode;
              }
            }
          }
          this.list[2][0].key = '';
          dataCopy.fbCustomerType.forEach(item => {
            this.list[2][0].key += `${item.fieldName},`;
          });
          this.list[2][0].key = this.list[2][0].key.substring(0, this.list[2][0].key.length - 1);
          this.list[2][1].key = dataCopy.mactFeedback.customerAmount;
          this.list[3][0].key = dataCopy.mactFeedback.isUnionMarket === 1 ? '是' : '否';
          this.list[3][1].key = dataCopy.mactFeedback.unionCustomer;
          this.list[3][1].key = dataCopy.mactFeedback.unionCustomerType;
          this.list[3][2].key = dataCopy.mactFeedback.unionCustomer;
          this.list[4][0].key = '';
          dataCopy.fbActivityDuty.forEach(item => {
            this.list[4][0].key += `${item.fieldValue},`;
          });
          this.list[4][0].key = this.list[4][0].key.substring(0, this.list[4][0].key.length - 1);
          this.list[5][0].list = [];
          if (dataCopy.fbMeeting.length > 0) {
            let str = '';
            dataCopy.fbMeeting.forEach(item => {
              str += `${item.fieldValue},`;
            });
            str = str.substring(0, str.length - 1);
            this.list[5][0].list.push(`会议：${str}`);
          }
          if (dataCopy.fbProductExperience.length > 0) {
            let str = '';
            dataCopy.fbProductExperience.forEach(item => {
              str += `${item.fieldValue},`;
            });
            str = str.substring(0, str.length - 1);
            this.list[5][0].list.push(`产品体验：${str}`);
          }
          if (dataCopy.fbTemplate.length > 0) {
            let str = '';
            dataCopy.fbTemplate.forEach(item => {
              str += `${item.fieldValue},`;
            });
            str = str.substring(0, str.length - 1);
            this.list[5][0].list.push(`样板参观：${str}`);
          }
          if (dataCopy.fbLiveBroadcast.length > 0) {
            let str = '';
            dataCopy.fbLiveBroadcast.forEach(item => {
              str += `${item.fieldValue},`;
            });
            str = str.substring(0, str.length - 1);
            this.list[5][0].list.push(`线上直播：${str}`);
          }
          if (dataCopy.fbExhibition.length > 0) {
            let str = '';
            dataCopy.fbExhibition.forEach(item => {
              str += `${item.fieldValue},`;
            });
            str = str.substring(0, str.length - 1);
            this.list[5][0].list.push(`展会：${str}`);
          }
          if (dataCopy.fbCase.length > 0) {
            let str = '';
            dataCopy.fbCase.forEach(item => {
              str += `${item.fieldValue},`;
            });
            str = str.substring(0, str.length - 1);
            this.list[5][0].list.push(`策划案：${str}`);
          }
          if (dataCopy.fbSupport.length > 0) {
            let str = '';
            dataCopy.fbSupport.forEach(item => {
              str += `${item.fieldValue},`;
            });
            str = str.substring(0, str.length - 1);
            this.list[5][0].list.push(`特殊支持：${str}`);
          }
          if (dataCopy.fbCustomerPlatform.length > 0) {
            let str = '';
            dataCopy.fbCustomerPlatform.forEach(item => {
              str += `${item.fieldValue},`;
            });
            str = str.substring(0, str.length - 1);
            this.list[5][0].list.push(`客户站台：${str}`);
          }
          if (dataCopy.fbExperience.length > 0) {
            let str = '';
            dataCopy.fbExperience.forEach(item => {
              str += `${item.fieldValue},`;
            });
            str = str.substring(0, str.length - 1);
            this.list[5][0].list.push(`体验中心参观：${str}`);
          }

          this.list[6][0].key = '';
          dataCopy.fbReportOptimization.forEach(item => {
            if (item.fieldValue === '其他') {
              this.list[6][0].key += `${item.fieldValue + ':' + item.note},`;
            } else {
              this.list[6][0].key += `${item.fieldValue},`;
            }
          });
          this.list[6][0].key = this.list[6][0].key.substring(0, this.list[6][0].key.length - 1);
          this.list[6][1].key = '';
          dataCopy.mactFeedback.supporter.split(';').forEach(item => {
            if (item !== '') {
              this.list[6][1].key += `${item.split('|')[1]},`;
            }
          });
          this.list[6][1].key = this.list[6][1].key.substring(0, this.list[6][1].key.length - 1);
          this.list[7][0].key = dataCopy.mactFeedback.isFillQuestionnaire === 1 ? '是' : '否';
          this.list[7][1].key = dataCopy.mactFeedback.unCollectionReason;
          this.list[8][0].key = dataCopy.mactFeedback.questionnaireAmount;
          this.list[8][1].key = dataCopy.mactFeedback.salesLeadAmount;

          // 简化表单模式下隐藏指定字段
          if (this.useSimplifiedForm) {
            // 品推支持情况（list[1]，仅新版数据时存在）
            if (this.list[1] && this.list[1].length === 1 && this.list[1][0].title === '品推支持情况') {
              this.list[1][0].key = '';
            }
            // 客户类型
            this.list[2][0].key = '';
            // 是否联合活动及其子字段
            this.list[3][0].key = '';
            this.list[3][1].key = '';
            this.list[3][2].key = '';
            // 是否做了问卷及子字段
            this.list[7][0].key = '';
            this.list[7][1].key = '';
            // 问卷数、线索数
            this.list[8][0].key = '';
            this.list[8][1].key = '';
            // 是否重要活动、备注（list[9]，仅新版数据时存在）
            if (this.list[9]) {
              if (this.list[9][0]) this.list[9][0].key = '';
              if (this.list[9][1]) this.list[9][1].key = '';
            }
          }
        }
      } catch (e) {

      }
      this.detailsStatus = false;
    },
    handleClose () {
      this.dialogVisible = false;
    },
    handleSubmit () {
      // this.refs.formData.validate((valid) => {
      // if (valid) {}
      // });
    }
  }
};
</script>

<style lang="scss">
  #ExecutionFeedbackModel {

  }
</style>
